<mat-horizontal-stepper [linear]="false" #stepper class="config-stepper">
  <mat-step *ngFor="let modulo of modulos">
    <ng-template matStepLabel>{{modulo['nombre']}}</ng-template>
    <app-module-config [moduloId]="modulo['id']"></app-module-config>
    <button class="button-general" (click)="nextStep()">Siguiente</button>
  </mat-step>
</mat-horizontal-stepper>
